import { useToast } from "@chakra-ui/react";

export function useErrorMessage() {
  const toast = useToast();

  const showErrorMessage = (e: any, custom_messages?: string[]) => {
    const errors_messages = e.message.split(":");

    if (errors_messages[0] === "not_permitted") {
      toast({
        status: "error",
        description: "Tidak diijinkan!",
      });
    }

    let message = "";
    switch (e.message) {
      case "cannot_set_default_to_disabled_data":
        message = "Cannot set default to disabled data!";
        break;
    }

    toast({
      status: "error",
      description: message || e.message,
    });
  };

  return { showErrorMessage };
}
